import { render } from "./icon-gr-wallet.svg?vue&type=template&id=24613076?inline"
const script = {}
script.render = render

export default script